/**
 * English language
 * @type {Object}
 *
 * Example: {{ $t('someWord') }}
 */

const en = {
  helloWorld: 'Hello my world!'
}

export default en
